import "./Sub.css";
import "./SubResponsive.css";

export function Sub() {
	return `
    <section class="sub">
			<div class="container">
				<p class="sub_text">Dreamlike Sound</p>
				<p class="sub_price">Starting at $320 — Available Now.</p>
				<button class="sub_btn">Buy Now</button>
			</div>
		</section>
  `;
}